import SettingHeader from "../SettingHeader";
import Button from "../../../../../common/components/button";
import SelectBox from "../../../../components/common/selectBox";
import Input from "../../../../components/common/input";
import WordTable from "./WordTable";
import ModifyWord from "./ModifyWord";
import React, { useEffect, useState } from "react";
import NewWord from "./NewWord";
import { useGetWord } from "../../../../../common/hooks/console/management/word/useGetWord";
import { useSystemPopStore } from "../../../../store/useSystemPopStore";
import useToastStore from "../../../../store/useToastStore";
import { useDeleteWord } from "../../../../../common/hooks/console/management/word/useDeleteWord";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/closeIcon.svg";
import { useGetWordCategory } from "../../../../../common/hooks/console/management/word/useGetWordCategory";
import { usePutWordCategory } from "../../../../../common/hooks/console/management/word/usePutWordCategory";
import { useAuthStore } from "../../../../store/useAuthStore";

const Word = () => {
    const { showPop } = useSystemPopStore();
    const { addToast } = useToastStore();
    const level = useAuthStore(state => state.m_level);

    const [currentPage, setCurrentPage] = useState<number>(1);
    const [search, setSearch] = useState<string>("search_word");
    const [searchTxt, setSearchTxt] = useState<string>("");
    const [idx, setIndex] = useState<number | null>(null);
    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [categoryPop, setCategoryPop] = useState<boolean>(false);
    const [selectedCategory, setSelectedCategory] = useState<string>("");
    const [categoryError, setCategoryError] = useState<boolean>(false);

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const { data: categoryData } = useGetWordCategory();
    const categoryOptions = categoryData
        ? categoryData.map(cat => ({
              value: cat.event_category_idx.toString(),
              label: cat.event_name,
          }))
        : [];

    const { data: listData } = useGetWord(currentPage, 20, search, searchTxt);
    const deleteWordMutation = useDeleteWord();
    const handleDelete = (deleteIdx?: number) => {
        const updatedSelectedRows = deleteIdx ? Array.from(new Set([...selectedRows, deleteIdx])) : selectedRows;

        showPop({
            title: "해당 내역을 삭제하시겠습니까",
            rightButton: "확인",
            type: "negative",
            onRightClick: () => {
                addToast({
                    type: "delete",
                    onConfirmDelete: () => {
                        deleteWordMutation.mutate(
                            { word_idx: updatedSelectedRows },
                            {
                                onSuccess: () => {
                                    setIndex(prevIdx => {
                                        if (prevIdx === null) {
                                            return prevIdx;
                                        }
                                        const remainingItems =
                                            listData?.data_list?.filter(item => !updatedSelectedRows.includes(item.word_idx)) ?? [];

                                        const newIdx = updatedSelectedRows.includes(prevIdx)
                                            ? (remainingItems[0].word_idx ?? null)
                                            : prevIdx;

                                        return newIdx;
                                    });
                                },
                            },
                        );
                    },
                });
            },
        });
    };

    const putWordCategoryMutation = usePutWordCategory();
    const handleMoveCategory = () => {
        let hasError = false;
        if (!selectedCategory) {
            setCategoryError(true);
            hasError = true;
        }
        if (hasError) return;
        putWordCategoryMutation.mutate(
            {
                word_idx: selectedRows,
                event_category_idx: parseInt(selectedCategory),
            },
            {
                onSuccess: () => {
                    setCategoryPop(false);
                    setSelectedCategory("");
                    setSelectedRows([]);
                    addToast({ type: "success", message: "카테고리 이동이 완료되었습니다." });
                },
            },
        );
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [searchTxt]);

    // useEffect(() => {
    //     if (listData?.data_list?.length || (0 > 0 && idx === null)) {
    //         setIndex(listData?.data_list[0].word_idx || null);
    //     }
    // }, [listData]);

    return (
        <div className="flex overflow-hidden h-dvh">
            <div className="flex flex-col w-full">
                <SettingHeader totalPage={listData?.last_page} currentPage={currentPage} onPageChange={handlePageChange} />
                <div className="flex-1 flex flex-col overflow-hidden">
                    <div className="flex justify-between px-3 py-3.5 items-center border-b border-gray4">
                        <div className="flex items-center gap-2">
                            <div className="flex gap-1 items-center ">
                                <p className="text-xs">총</p>
                                <button className="text-sm font-bold text-primary2">{listData?.total_count.toLocaleString() || 0}</button>
                            </div>
                            <div className="flex gap-1 items-center ">
                                <p className="text-xs">선택</p>
                                <button className="text-sm font-bold text-primary2">{selectedRows.length}</button>
                            </div>
                            <div className="flex relative">
                                {level !== 7 && (
                                    <Button
                                        size="S"
                                        disabled={selectedRows.length === 0}
                                        className="px-2"
                                        onClick={() => setCategoryPop(true)}
                                    >
                                        카테고리 이동
                                    </Button>
                                )}
                                {categoryPop && (
                                    <div className="absolute bg-white translate-y-10 w-[480px] shadow-custom rounded-2xl">
                                        <div className="flex px-6 py-5 justify-between items-center">
                                            <p className="text-2xl font-bold ">카테고리 이동</p>
                                            <CloseIcon
                                                onClick={() => {
                                                    setSelectedCategory("");
                                                    setCategoryPop(false);
                                                    setCategoryError(false);
                                                }}
                                                className="cursor-pointer"
                                            />
                                        </div>
                                        <div className="flex flex-col px-6 pb-5 gap-4">
                                            <div className="flex text-xl font-bold">
                                                <p>선택한 내역</p>
                                                <p className="text-error pl-1.5">{selectedRows.length}</p>
                                                <p>개를 이동합니다.</p>
                                            </div>
                                            <div className="flex gap-2 w-full">
                                                <SelectBox
                                                    status={categoryError ? "error" : ""}
                                                    className="w-full"
                                                    placeholder="이동할 카테고리를 선택해주세요."
                                                    options={categoryOptions}
                                                    value={selectedCategory}
                                                    onChange={value => {
                                                        setSelectedCategory(value);
                                                        setCategoryError(false);
                                                    }}
                                                />
                                                <Button onClick={handleMoveCategory} className="w-20" size="S" status="regist">
                                                    이동
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            {level !== 7 && level !== 8 && (
                                <Button
                                    className="px-2"
                                    size="S"
                                    status="error"
                                    onClick={() => handleDelete(idx || undefined)}
                                    disabled={selectedRows.length === 0}
                                >
                                    삭제
                                </Button>
                            )}
                        </div>

                        <div className="flex gap-2 items-center">
                            {level !== 7 && (
                                <Button onClick={() => setIndex(null)} size="S" className="px-2" status="regist">
                                    경조사어 등록
                                </Button>
                            )}
                            <div className="w-[240px] flex gap-1">
                                <SelectBox
                                    status="none"
                                    className="min-w-[100px]"
                                    options={[
                                        { value: "search_word", label: "검색어" },
                                        { value: "wreath_word", label: "경조사어" },
                                        { value: "event_name", label: "카테고리" },
                                    ]}
                                    value={search}
                                    onChange={(value: string) => setSearch(value)}
                                />
                                <Input
                                    placeholder="검색"
                                    status="none"
                                    className=""
                                    value={searchTxt}
                                    onChange={e => setSearchTxt(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="flex-1 overflow-y-auto">
                        <WordTable
                            data={listData?.data_list}
                            selectedRow={idx}
                            selectedRows={selectedRows}
                            onRowClick={idx => {
                                setIndex(idx);
                            }}
                            onRowSelect={setSelectedRows}
                        />
                    </div>
                </div>
            </div>

            <div className="md:min-w-[620px] min-w-[560px] h-dvh overflow-y-auto bg-gray6 flex flex-col p-4">
                {idx !== null ? <ModifyWord idx={idx} onDelete={handleDelete} /> : <NewWord onWordCreated={wordIdx => setIndex(wordIdx)} />}
            </div>
        </div>
    );
};

export default Word;
